import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  standalone: true,
  name: 'tmwAbbreviate',
})
export default class TmwAbbreviate implements PipeTransform {
  transform(value: string, limit: number = 100, ellipsis: string = '...'): string {
    if (!value) {
      return value;
    }
    if (value.length <= limit) {
      return value;
    }
    return value.substring(0, limit) + ellipsis;
  }
}
